import type { CSSProperties } from "react";
import { cn } from "@/lib/utils";
import { api, type MediaAsset } from "@/lib/api";

/** Ani szerokość, ani wysokość podglądu nie może przekroczyć 250px. */
export const MEDIA_THUMB_MAX_PX = 250;

/** Inline, żeby limit działał nawet przy starym CSS z cache / Tailwind JIT. */
export const MEDIA_THUMB_LIMIT_STYLE: CSSProperties = {
  maxWidth: MEDIA_THUMB_MAX_PX,
  maxHeight: MEDIA_THUMB_MAX_PX,
};

export const MEDIA_THUMB_FRAME =
  "inline-flex items-center justify-center overflow-hidden rounded-md bg-muted";

export const MEDIA_THUMB_CLASS = "object-contain";

export function mediaAlt(asset: Pick<MediaAsset, "id" | "note" | "original_name">): string {
  const note = (asset.note || "").trim();
  if (note) return note;
  return asset.original_name || "Zdjęcie";
}

export function isMediaVideo(asset: Pick<MediaAsset, "kind" | "mime">): boolean {
  return asset.kind === "video" || (asset.mime || "").startsWith("video/");
}

export function MediaThumb({
  asset,
  src,
  className,
}: {
  asset: Pick<MediaAsset, "id" | "note" | "original_name">;
  src?: string;
  className?: string;
}) {
  return (
    <span className={cn(MEDIA_THUMB_FRAME, className)} style={MEDIA_THUMB_LIMIT_STYLE}>
      <img
        src={src || api.mediaFile(asset.id, true)}
        alt={mediaAlt(asset)}
        className={MEDIA_THUMB_CLASS}
        style={{ ...MEDIA_THUMB_LIMIT_STYLE, width: "auto", height: "auto", objectFit: "contain" }}
      />
    </span>
  );
}
